import api from '@utils/api';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import checkoutSlice from './checkout.slice';
import { CheckoutActionTypes } from './common.types';
function* handleFetchPickup() {
    const storesData = yield call(api.getStoresForPickup);
    yield put(checkoutSlice.actions.updatePickupData(storesData));
}
function* handleFetchCheckoutData() {
    const checkoutData = yield call(api.getCheckoutData);
    yield put(checkoutSlice.actions.updateCheckoutData(checkoutData));
}
function* handleFetchAddresses() {
    const addressbook = yield call(api.getAddressBook);
    if (addressbook) {
        const addresses = addressbook.addresses;
        const countryCode = yield select((state) => state.checkout.countryCode);
        const countryAddresses = addresses.filter((address) => { var _a; return ((_a = address.countryCode) === null || _a === void 0 ? void 0 : _a.value) === countryCode; });
        yield put(checkoutSlice.actions.updateAddresses(countryAddresses));
    }
}
function* handleFetchPaymentMethods() {
    const adyenPaymentMethodsResponse = yield call(api.getPaymentMethods);
    yield put(checkoutSlice.actions.updatePaymentMethods(adyenPaymentMethodsResponse));
}
function* handleUpdateOrder(action) {
    yield put(checkoutSlice.actions.updateOrder(action.payload));
}
function* handleUpdateShippingMethod(action) {
    yield put(checkoutSlice.actions.updateShippingMethods(action.payload));
}
function* handleUpdateCustomer(action) {
    yield put(checkoutSlice.actions.updateCustomer(action.payload));
}
function* handleUpdateEmail(action) {
    yield put(checkoutSlice.actions.updateEmail(action.payload));
}
function* handleUpdateNexiNonce(action) {
    yield put(checkoutSlice.actions.updateNexiNonce(action.payload));
}
function* handleUpdatePaymentMethod(action) {
    yield put(checkoutSlice.actions.updatePaymentMethod(action.payload));
}
function* handleUpdateActivationAddress(action) {
    yield put(checkoutSlice.actions.updateActivationAddress(action.payload));
}
function* watchFetchRequest() {
    yield takeEvery(CheckoutActionTypes.FETCH_CHECKOUTDATA, handleFetchCheckoutData);
    yield takeEvery(CheckoutActionTypes.FETCH_ADDRESSES, handleFetchAddresses);
    yield takeEvery(CheckoutActionTypes.FETCH_PAYMENTMETHODS, handleFetchPaymentMethods);
    yield takeEvery(CheckoutActionTypes.UPDATE_ORDER, handleUpdateOrder);
    yield takeEvery(CheckoutActionTypes.UPDATE_EMAIL, handleUpdateEmail);
    yield takeEvery(CheckoutActionTypes.FETCH_PICKUP, handleFetchPickup);
    yield takeEvery(CheckoutActionTypes.UPDATE_SHIPPINGMETHODS, handleUpdateShippingMethod);
    yield takeEvery(CheckoutActionTypes.UPDATE_CUSTOMER, handleUpdateCustomer);
    yield takeEvery(CheckoutActionTypes.UPDATE_NONCE, handleUpdateNexiNonce);
    yield takeEvery(CheckoutActionTypes.UPDATE_PAYMENTMETHOD, handleUpdatePaymentMethod);
    yield takeEvery(CheckoutActionTypes.UPDATE_ACTIVATIONADDRESS, handleUpdateActivationAddress);
}
export default function* bagSaga() {
    yield all([fork(watchFetchRequest)]);
}
